var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 274,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 274",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m188.81319 178.874645c32.459028-17.822918 57.067107-31.403792 59.188129-32.459027 6.785161-3.608904 13.791921-13.15878 0-20.577082-4.453091-2.332069-28.42803-15.490849-59.188129-32.4590268l-42.642044 43.0641388z",
    fill: "#ffd900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m146.171146 136.443648-135.7770817 136.842869c3.1868096.422094 6.7851608-.422094 11.0272053-2.754164 8.906183-4.875185 103.3180544-56.433965 167.3919204-91.647155z",
    fill: "#f43249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m146.171146 136.443648 42.642044-42.8530918s-157.8420441-86.13882935-167.3919204-91.22506183c-3.5983512-2.13157461-7.6293487-2.76471558-11.2382523-2.13157461z",
    fill: "#00ee76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m146.171146 136.443648-135.9881287-136.20972824c-5.5188788 1.27683429-10.1830173 6.15201978-10.1830173 16.12399014v240.8046171c0 9.127782 3.60890354 15.701896 10.3940643 16.335037z",
    fill: "#00d3ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.23c0abf31c45d7f53ee6c825b6d672c9.svg";
export { ForwardRef as ReactComponent };